import { createSlot } from "./createSlot.js";
const createStyledSlotOrClone = ({
  element,
  slotRef
}) => {
  const elementRef = element.querySelector(
    `:scope > [slot=${slotRef}]`
  );
  if (!elementRef) return null;
  const isStyled = elementRef.hasAttribute("styled");
  if (isStyled) {
    return createSlot(slotRef);
  }
  const clonedElement = elementRef.cloneNode(true);
  clonedElement.removeAttribute("slot");
  return clonedElement;
};
export {
  createStyledSlotOrClone
};
//# sourceMappingURL=createStyledSlotOrClone.js.map
